const translations = {
  "en": {
    "No email?": "No email?",
    "Resend": "Resend",
    "Resend in %{var0}": "Resend in %{var0}"
  },
  "zh-tw": {
    "No email?": "沒有電子郵件？",
    "Resend": "重新傳送",
    "Resend in %{var0}": "重新傳送於 %{var0}"
  }
};

export default translations;
